import React, { Component } from "react";

class AdminNavbarLinks extends Component {
  render() {
    return (
      <div>
      </div>
    );
  }
}

export default AdminNavbarLinks;
